// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Image from '/react4xp/components/Image'
import RichText from '/react4xp/components/RichText'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

interface HighlightedCardSectionProps {
    cardBgColor: 'beige' | 'blue' | 'green'
    image?: {
		src: string
		alt?: string
	}
    title?: string
    text?: string
}

export default function HighlightedCardSection({
    cardBgColor,
    image,
    title,
    text
}: HighlightedCardSectionProps) {
    return (
        <Section
            textColor='text-dark'
            className='highlighted-card-section'
        >
            <div className='grid-container'>
                <div className='grid-row'>
                    <div className='c-md-10 start-md-2 c-xl-8 start-xl-3'>
                        <div className={clsx(
                            'highlighted-card-section__block',
                            cardBgColor === 'beige' && 'highlighted-card-section__block--beige',
                            cardBgColor === 'blue' && 'highlighted-card-section__block--blue',
                            cardBgColor === 'green' && 'highlighted-card-section__block--green',
                            !image?.src && 'highlighted-card-section__block--no-image'
                        )}>

                            {image?.src && (
                                <Image
                                    src={image.src}
                                    alt={image.alt}
                                    className='highlighted-card-section__image'
                                />
                            )}

                            <div className='highlighted-card-section__content'>

                                {isNonWhitespaceString(title) && (
                                    <h2 className='highlighted-card-section__title text-md'>
                                        {title}
                                    </h2>
                                )}

                                {isNonWhitespaceString(text) && (
                                    <div className='highlighted-card-section__text'>
                                        <RichText content={text} />
                                    </div>
                                )}

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </Section>
    )
}

